import React from 'react';
import { Row, Col, Card, Badge } from 'react-bootstrap';
import { InfoRow } from './InfrastructureSectionPanel';

const InfrastructureRuntimePanel = ({ data }) => (
    <Row className="g-3">
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Node.js</div>
                    <InfoRow label="Node Version" value={data.nodeVersion} />
                    <InfoRow label="V8 Version" value={data.v8Version} />
                    <InfoRow label="Platform" value={data.platform} />
                    <InfoRow label="Architecture" value={data.arch} />
                </Card.Body>
            </Card>
        </Col>
        <Col md={6}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Process</div>
                    <InfoRow label="PID" value={data.pid} />
                    <InfoRow label="PPID" value={data.ppid} />
                    <InfoRow label="Title" value={data.title} />
                    <InfoRow label="Debug Port" value={data.debugPort} />
                    <InfoRow label="Uptime" value={data.uptimeFormatted} />
                </Card.Body>
            </Card>
        </Col>
        <Col xs={12}>
            <Card className="border-0 bg-light">
                <Card.Body className="py-2 px-3">
                    <div className="small fw-semibold mb-2 text-secondary">Executable</div>
                    <InfoRow label="Exec Path" value={data.execPath} />
                    {data.features && (
                        <div className="mt-2">
                            <div className="text-muted small mb-1">Features</div>
                            <div className="d-flex flex-wrap gap-1">
                                {Object.entries(data.features).map(([k, v]) => (
                                    <Badge key={k} bg={v ? 'success' : 'secondary'} className="fw-normal" style={{ fontSize: '0.7rem' }}>
                                        {k}
                                    </Badge>
                                ))}
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Col>
    </Row>
);

export default InfrastructureRuntimePanel;
